<template>
  <div class="empty">
    <template v-if="type === 'order'">
      <img src="/img/user/common/empty_order.svg" v-if="!dark" alt="" />
      <img src="/img/user/common/empty_order_dark.svg" v-else alt="" />
      <p>{{$t('helper.no-orders')}}</p>
    </template>
    <template v-else-if="type === 'trade'">
      <img src="/img/user/common/empty_trade.svg" v-if="!dark" alt="" />
      <img src="/img/user/common/empty_trade_dark.svg" v-else alt="" />
      <p>{{$t('helper.no-orders')}}</p>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState('common', ['dark']),
  },
}
</script>

<style lang="scss">
@import './Empty.scss';
</style>
